import Events from '../lib/events.js';
import { t9n } from '../lib/translate.js';
import { TS } from '../config/translation-keys.js';
import APIClient from '../state-charts/api-client';

export default class DonateMachine {
  constructor(options) {
    this.make_context(options);
    this.add_computed_context();
  }

  make_context(options) {
    this.context = {
      // original context
      ...options.context,

      // static/parent data
      id: options.id,
      main: options.main,
      minimum_amount: options.main.context.pp_minimum,
      multiplier: options.main.context.pp_multiplier,
      currency_sign: options.main.context.currency_sign,
      amount: options.main.context.amount,

      // variables
      donate_amount: null,
      comment: null,
      email: null,
      email_confirm: null,
      errors: {
        donate_amount: '',
        comment: '',
        email: '',
        email_confirm: '',
      },
      valid: false,
      show_error: false,
      processing: false,
      show_confirm: false,
      confirmed: false,
    };
  }

  add_computed_context() {
    // calculated variables
    this.context.cash_amount = Number(
      this.context.amount / this.context.multiplier
    ).toFixed(2);

    this.context.donate_price = this.context.donate_amount
      ? (Number(this.context.donate_amount) / this.context.multiplier).toFixed(
          2
        )
      : 0;

    this.context.donate_amount_errors =
      this.context.show_error &&
      this.context.errors &&
      !!this.context.errors.donate_amount;

    this.context.comment_errors =
      this.context.show_error &&
      this.context.errors &&
      !!this.context.errors.comment;

    this.context.email_errors =
      this.context.show_error &&
      this.context.errors &&
      !!this.context.errors.email;

    this.context.email_confirm_errors =
      this.context.show_error &&
      this.context.errors &&
      !!this.context.errors.email_confirm;

    this.context.amount_text = `${this.context.amount} (${this.context.cash_amount} ${this.context.currency_sign})`;

    // translations
    this.context.form_title = t9n(TS.PILOT_POINTS_DONATE_FORM_TITLE);

    this.context.explanation_1 = t9n(TS.PILOT_POINTS_DONATE_EXPLANATION_LINE1);

    this.context.explanation_2 = t9n(TS.PILOT_POINTS_DONATE_EXPLANATION_LINE2);

    this.context.explanation_3 = t9n(TS.PILOT_POINTS_DONATE_EXPLANATION_LINE3);

    this.context.your_pp_label = t9n(TS.PILOT_POINTS_DONATE_YOUR_PP_LABEL);

    this.context.donate_amount_label = t9n(TS.PILOT_POINTS_DONATE_AMOUNT_LABEL);

    this.context.leave_comment_label = t9n(
      TS.PILOT_POINTS_DONATE_LEAVE_COMMENT_LABEL
    );

    this.context.send_to_label = t9n(TS.PILOT_POINTS_DONATE_SEND_TO_LABEL);

    this.context.comment_label = t9n(TS.PILOT_POINTS_DONATE_YOUR_COMMENT_LABEL);

    this.context.email_label = t9n(TS.PILOT_POINTS_DONATE_EMAIL_LABEL);

    this.context.confirm_email_label = t9n(
      TS.PILOT_POINTS_DONATE_CONFIRM_EMAIL_LABEL
    );

    this.context.donate_label = t9n(TS.PILOT_POINTS_DONATE_DONATE_LABEL);

    this.context.confirm_yes_label = t9n(
      TS.PILOT_POINTS_DONATE_CONFIRM_YES_LABEL
    );

    this.context.confirm_no_label = t9n(
      TS.PILOT_POINTS_DONATE_CONFIRM_CANCEL_LABEL
    );

    this.context.confirm_title = t9n(TS.PILOT_POINTS_DONATE_CONFIRM_TITLE);

    this.context.confirm_donation_text = t9n(
      TS.PILOT_POINTS_DONATE_CONFIRM_TEXT,
      this.context.donate_amount,
      this.context.email
    );

    this.context.donation_total_text = t9n(
      TS.PILOT_POINTS_DONATE_TOTAL_TEXT,
      this.context.donate_price,
      this.context.currency_sign
    );

    this.context.donation_success_message = t9n(
      TS.PILOT_POINTS_DONATE_SUCCESS_TEXT,
      new Number(this.context.donate_amount).toFixed(2),
      this.context.email
    );

    this.context.amount_too_low_text = t9n(
      TS.PILOT_POINTS_DONATE_ERROR_AMOUNT_TOO_LOW,
      this.context.minimum_amount
    );

    this.context.amount_is_nan_text = t9n(
      TS.PILOT_POINTS_DONATE_ERROR_AMOUNT_IS_NAN
    );
    this.context.amount_is_invalid_text = t9n(
      TS.PILOT_POINTS_DONATE_ERROR_AMOUNT_IS_NAN
    );
    this.context.not_enough_pp_text = t9n(
      TS.PILOT_POINTS_DONATE_ERROR_AMOUNT_TO_HIGH
    );
    this.context.email_no_at_text = t9n(
      TS.PILOT_POINTS_DONATE_ERROR_EMAIL_HAS_NO_AT
    );
    this.context.email_too_many_at_text = t9n(
      TS.PILOT_POINTS_DONATE_ERROR_EMAIL_HAS_TOO_MANY_AT
    );
    this.context.email_sbort_name_text = t9n(
      TS.PILOT_POINTS_DONATE_ERROR_EMAIL_SHORT_NAME
    );
    this.context.email_sbort_domain_text = t9n(
      TS.PILOT_POINTS_DONATE_ERROR_EMAIL_SHORT_DOMAIN
    );
    this.context.no_email_text = t9n(
      TS.PILOT_POINTS_DONATE_ERROR_EMAIL_CONFIRM_NO_EMAIL
    );
    this.context.wrong_email_confirm_text = t9n(
      TS.PILOT_POINTS_DONATE_ERROR_EMAIL_CONFIRM_WRONG
    );
  }

  update_context(context) {
    this.context = { ...this.context, ...context };
    this.add_computed_context();
  }

  update_amount(amount) {
    // this.context.amount = amount;

    // this.context.main.update_pp_amount(this.context.amount);

    Events.dispatch('ppamountchanged', { amount: amount });
  }

  validate_amount() {
    let num = Number(this.context.donate_amount);

    if (Number.isNaN(num)) {
      return this.context.amount_is_invalid_text;
    }

    if (this.context.donate_amount > this.context.amount) {
      return this.context.not_enough_pp_text;
    }

    if (this.context.donate_amount < this.context.minimum_amount) {
      return this.context.amount_too_low_text;
    }

    return '';
  }

  validate_comment() {
    return '';
  }

  validate_email() {
    let parts = this.context.email.trim().split('@');

    if (parts.length < 2) {
      return this.context.email_no_at_text;
    }

    if (parts.length > 2) {
      return this.context.email_too_many_at_text;
    }

    if (parts[0].length < 2) {
      return this.context.email_sbort_name_text;
    }

    if (parts.length === 2 && parts[1].length < 5) {
      return this.context.email_sbort_domain_text;
    }

    return '';
  }

  validate_email_confirm() {
    if (!this.context.email) {
      return this.context.no_email_text;
    }

    if (this.context.email !== this.context.email_confirm) {
      return this.context.wrong_email_confirm_text;
    }

    return '';
  }

  validate() {
    if (!!this.context.donate_amount) {
      this.context.errors.donate_amount = this.validate_amount();
    }

    if (!!this.context.comment) {
      this.context.errors.comment = this.validate_comment();
    }

    if (!!this.context.email) {
      this.context.errors.email = this.validate_email();
    }

    if (!!this.context.email_confirm) {
      this.context.errors.email_confirm = this.validate_email_confirm();
    }

    this.context.valid =
      !!this.context.donate_amount &&
      !this.context.errors.donate_amount &&
      !this.context.errors.comment &&
      !!this.context.email &&
      !this.context.errors.email &&
      !!this.context.email_confirm &&
      !this.context.errors.email_confirm;
  }

  async donate() {
    let data = {
      amount: this.context.donate_amount,
      comment: this.context.comment,
      email: this.context.email,
    };

    this.context.processing = true;
    let response = await APIClient.donate_pilot_points(data);
    this.context.processing = false;

    if (!!response && !!response.pilot_points) {
      this.update_amount(response.pilot_points);
      return {
        message: this.context.donation_success_message,
        type: 'success',
      };
    }
  }

  reset_state() {
    this.context.confirmed = false;
    this.context.show_confirm = false;
    this.context.valid = false;
    this.context.show_error = false;
    this.context.errors = {
      donate_amount: '',
      comment: '',
      email: '',
      email_confirm: '',
    };
    this.context.processing = false;
    this.context.donate_amount = '';
    this.context.comment = '';
    this.context.email = '';
    this.context.email_confirm = '';
  }
}
